import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title, Meta, SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import * as mammoth from 'mammoth';

// 1. Creamos una interfaz para manejar cada acordeón de forma individual
export interface FaqItem {
  question: string;
  answerHtml: string;
  safeAnswerHtml?: SafeHtml;
}

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {
  title = 'Preguntas frecuentes | Sorteo Anáhuac 11ª Edición';
  description = '¿Tienes algunas dudas? Consulta aquí las preguntas más frecuentes del Sorteo Anáhuac 11ª Edición.';

  // 2. En lugar de un solo htmlContent, tendremos un arreglo de preguntas
  faqsList: FaqItem[] = [];

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    // ... (Tu código de configuración de SEO y JQuery se mantiene igual) ...
    
    this.cargarLegal();
  }

  cargarLegal() {
    const url = '/assets/docs/faqs.docx';

    this.http.get(url, { responseType: 'arraybuffer' }).subscribe({
      next: (arrayBuffer: ArrayBuffer) => {
        mammoth.convertToHtml({ arrayBuffer: arrayBuffer })
          .then((result) => {
            // 3. Pasamos el HTML generado a una función que lo "despedace"
            this.parseMammothHtml(result.value);

            if (result.messages.length > 0) {
              console.warn('Mensajes de Mammoth:', result.messages);
            }
          })
          .catch((error) => {
            console.error('Error al convertir el documento Word:', error);
          });
      },
      error: (error) => {
        console.error('Error al cargar el archivo de assets:', error);
      }
    });
  }

  // 4. Esta función agrupa las preguntas y respuestas
  parseMammothHtml(rawHtml: string) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = rawHtml;

    let currentFaq: FaqItem | null = null;
    this.faqsList = [];

    // Iteramos sobre todos los elementos generados (usualmente etiquetas <p>)
    Array.from(tempDiv.children).forEach((child: Element) => {
      const text = child.textContent?.trim() || '';
      
      // Condición para detectar si es un Título/Pregunta. 
      // Ajusta esta lógica si en el Word las preguntas vienen marcadas como <h1> o <h2>
      if (text.startsWith('¿') || text.startsWith('-')) {
        
        // Si ya teníamos una pregunta en progreso, la guardamos en el arreglo antes de empezar la nueva
        if (currentFaq) {
          currentFaq.safeAnswerHtml = this.sanitizer.bypassSecurityTrustHtml(currentFaq.answerHtml);
          this.faqsList.push(currentFaq);
        }
        
        // Iniciamos una nueva tarjeta
        currentFaq = {
          question: text.replace(/^-/, '').trim(), // Quitamos el guion inicial si lo tiene
          answerHtml: ''
        };
      } else {
        // Si no es título, es la respuesta, así que concatenamos el HTML
        if (currentFaq) {
          currentFaq.answerHtml += child.outerHTML;
        }
      }
    });

    // No olvidemos hacer push de la última pregunta al terminar el ciclo
    if (currentFaq) {
      currentFaq.safeAnswerHtml = this.sanitizer.bypassSecurityTrustHtml(currentFaq.answerHtml);
      this.faqsList.push(currentFaq);
    }
  }
}